export function serverErrorMessage(error, fallback) {
    var _a, _b;
    const candidate = error;
    const data = (_a = candidate === null || candidate === void 0 ? void 0 : candidate.response) === null || _a === void 0 ? void 0 : _a.data;
    const fromServer = (data === null || data === void 0 ? void 0 : data.error) || (((_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b.length) ? data.errors.join('\n') : '');
    if (fromServer)
        return fromServer;
    // Ours, not Axios's: a transport error carries `response`/`isAxiosError`, a hand-thrown one does
    // not. Checked by shape rather than `instanceof AxiosError`, which does not survive the mock
    // boundary in tests and is not reliable across axios instances.
    const isTransportError = Boolean((candidate === null || candidate === void 0 ? void 0 : candidate.isAxiosError) || (candidate === null || candidate === void 0 ? void 0 : candidate.response));
    if (!isTransportError && (candidate === null || candidate === void 0 ? void 0 : candidate.message))
        return candidate.message;
    return fallback || (candidate === null || candidate === void 0 ? void 0 : candidate.message) || '';
}
